import Request from './request';

async function fetch(data) {
  return Request('get', "api/template-price-adjust-tasks", data);
}

async function getAddItemInfo(data) {
  return Request('get', 'api/template-price-adjust-tasks/get-add-item-info', data);
}

async function add(data) {
  return Request('post', 'api/template-price-adjust-tasks/add', data);
}

async function view(id) {
  return Request('get', `api/template-price-adjust-tasks/view/${id}`);
}

async function cancel(id) {
  return Request('post', `api/template-price-adjust-tasks/cancel/${id}`);
}

async function edit(id, data) {
  return Request('post', `api/template-price-adjust-tasks/edit/${id}`, data);
}

export default {
  fetch,
  getAddItemInfo,
  add,
  view,
  cancel,
  edit,
};